import React from 'react';
import { DashboardNavbar } from '@/components/dashboard/DashboardNavbar';
import { HealthMonitor } from '@/components/dashboard/HealthMonitor';

export default function SystemHealthPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <DashboardNavbar />
      <div className="container mx-auto py-8 px-4">
        <HealthMonitor />
      </div>
    </div>
  );
}
